export default __webpack_public_path__ + "static/menu-flag-84a062f286048c201002c2e2dfc90960.png";